<template>
  <div class="img-box">
    <van-swipe indicator-color="white" v-if="imgList && imgList.length">
      <van-swipe-item  v-for="(item, index) in imgList" :key="index">
        <img :src="item.moduleDetailValue" mode="widthFix" />
      </van-swipe-item>
    </van-swipe>
    <img v-else src="https://img3.quanyou.com.cn/joyNew/group1/M00/21/D8/rB8LrmVd70OAcnxnAADXBbbRklY668.png" alt="" />
    
  </div>
</template>

<script>
import mixins from './mixins'
export default {
  mixins: [mixins],
}
</script>

<style lang="stylus" scoped>
  .img-box {
    width: 330px;
    height: 212px;
    margin: auto;
    border: 4px solid rgb(223, 219, 169)
    border-radius: 4px;
    img {
      width: 330px;
      height: 212px;
    }
  }
</style>